<template>
    <div v-loading.fullscreen.lock="fullscreenLoading" class="login-wrapper">
        <el-row type="flex" justify="center" align="center" v-show="visibility" style="height: 100%;">
            <el-col :span="8" class="row vertical-center elCol">
                <div style="text-align: center; width: 100%">
                    <h3 class="text-center"><label class="login-form-title">Basic login</label></h3>
                </div>
                <div style="margin-top: 10px">
                    Simple authorize on staging environment
                </div>
                <div style="margin-top: 10px; width: 100%">
                    <el-input ref="username" v-model="username" placeholder="username"
                              autocomplete="disabled" aria-autocomplete="none"/>
                </div>
                <div style="margin-top: 10px; width: 100%">
                    <el-input type="password" v-model="password" placeholder="password"/>
                </div>
                <div style="margin-top: 10px; width: 100%">
                    <el-button class="custom-button" style="width: 100%;" @click="basicLogin">Login</el-button>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import BasicLogin from "../../security/BasicLogin";
    import AlertService from "../../service/alert.service";
    import Pages from "../../router/Pages";

    export default {
        name: "BasicLogin",
        data() {
            return {
                visibility: true,
                fullscreenLoading: false,
                username: "",
                password: ""
            }
        },
        methods: {
            async basicLogin() {
                let success = await BasicLogin.set(this.username, this.password);
                console.log(success);
                if (success) {
                    await this.$router.push({path: Pages.redirect.path});
                } else {
                    AlertService.error(this.$t("login.loginFailMessage"));
                }
            }
        }

    }
</script>

<style lang="scss" scoped>

</style>